import { React, useState } from 'react';
import SiteIdentity from './components/SiteIdentity';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navigation from './components/Navigation';
import { Switch, Route, HashRouter } from 'react-router-dom';
import OurPeople from './components/pages/OurPeople';
import OurResearch from './components/pages/OurResearch';
import Aboutus from './components/pages/Aboutus';
import NewsandEvents from './components/pages/NewsandEvents';
import Footer from './components/Footer';
import Home from './components/pages/Home'
import Projects from './components/pages/Projects';
import Publications from './components/pages/Publications';
import StudyWithUs from './components/pages/StudyWithUs';
import Contactus from './components/pages/Contactus';

function App() {
  const [show, setShow] = useState(false)
  setInterval(() => {
    setShow(true)
  }, 2800);
  return <div>
    {/* {!show &&
      <img style={{ height: "100vh", width: "100%" }} alt="" src="images/Animation.gif" />
    } */}
    {show &&
      <div>
        <HashRouter>
          <SiteIdentity />
          <Navigation />

        {/* basename=`/#` */}
          {/* <div className="container" style={{ backgroundColor: "white", width: "100%" }}> */}
          <div basename={`/`} className="container" style={{ backgroundColor: "white", width: "100%" }}>
          {/* <div basename={`${serverConfig}`} className="container" style={{ backgroundColor: "white", width: "100%" }}> */}
            <Switch>
              <Route path={`/our-research`} component={OurResearch} />
              {/* <Route path={`${serverConfig}/our-research`} component={OurResearch} /> */}
              <Route path={`/our-people`} component={OurPeople} />
              {/* <Route path={`${serverConfig}/our-people`} component={OurPeople} /> */}
              <Route path={`/about-us`} component={Aboutus} />
              {/* <Route path={`${serverConfig}/about-us`} component={Aboutus} /> */}
              <Route path={`/newsandevents`} exact={true} component={NewsandEvents} />
              {/* <Route path={`${serverConfig}/newsandevents`} exact={true} component={NewsandEvents} /> */}
              <Route path={`/projects`} component={Projects} />
              {/* <Route path={`${serverConfig}/projects`} component={Projects} /> */}
              <Route path={`/publications`} component={Publications} />
              {/* <Route path={`${serverConfig}/publications`} component={Publications} /> */}
              <Route path={`/studywithus`} component={StudyWithUs} />
              {/* <Route path={`${serverConfig}/studywithus`} component={StudyWithUs} /> */}
              <Route path={`/contactus`} component={Contactus} />
              {/* <Route path={`${serverConfig}/contactus`} component={Contactus} /> */}
              <Route path={`/**`} component={Home} exact={true} />
              {/* <Route path={`${serverConfig}/**`} component={Home} exact={true} /> */}
            </Switch>
            <br />
            <br />
          </div>
        </HashRouter>
        <Footer />
      </div>
    }
  </div>;
}

export default App;
